import React from "react"
import {Route, Switch} from "react-router-dom"
import * as Util from "../common"
import UnsafeRegisterView from "./RegisterView"
import LoginView from "./LoginView"
import ResetPasswordView from "./ResetPasswordView"
import ConfirmResetPasswordView from "./ConfirmResetPasswordView"

// 'Registration' requires an anonymous account with a beta key. Unlike lots of
// other account systems, it's not the first step - you must start playing
// anonymously; step 2 is registration, connect an email to the anon account.
//
// Other pages here are unauthed.
const RegisterView = Util.withAllowed(UnsafeRegisterView)

export default function AuthRouter({match}) {
  //  <Route exact path={match.path} component={RankingsList} />
  return (
    <Switch>
      <Route path={match.path + "/register"} component={RegisterView} />
      <Route path={match.path + "/login"} component={LoginView} />
      <Route path={match.path + "/forgot"} component={ResetPasswordView} />
      <Route
        path={match.path + "/reset/:oobCode"}
        component={ConfirmResetPasswordView}
      />
      <Route component={Util.NotFoundView} />
    </Switch>
  )
}



// WEBPACK FOOTER //
// ./src/auth-signin/AuthRouter.js